import React, { ReactElement } from 'react';
import { useDropzone, FileRejection, DropEvent } from 'react-dropzone';

const Dropzone = ({ onDrop, accept, children }: DropzoneProps) => {
	// Initializing useDropzone hooks with options
	const { getRootProps, getInputProps, isDragActive } = useDropzone({
		onDrop,
		accept
	});

	/* 
    useDropzone hooks exposes two functions called getRootProps and getInputProps
    and also exposes isDragActive boolean
  */

	const containerClassName = isDragActive
		? 'dropzone-container active'
		: 'dropzone-container';

	return (
		<div {...getRootProps()}>
			<input className="dropzone-input" {...getInputProps()} />
			<div className={containerClassName}>
				{children}
			</div>
		</div>
	);
};

interface DropzoneProps {
	onDrop?: (<T extends File>(acceptedFiles: T[], fileRejections: FileRejection[], event: DropEvent) => void) | undefined;
	accept?: string | string[] | undefined;
	children?: ReactElement[] | undefined
}

export default Dropzone;